import React, { useEffect, useState } from "react";
import { DialogActions, Typography } from "@material-ui/core";
import { useFormikContext } from "formik";
import { Table } from "react-bootstrap";
import { Card } from "react-bootstrap";
import {
  FormSelectField,
  FormTextField,
} from "../../../../../partials/content/Forms/FormField";
import MapPlaces from "../../../../../partials/content/MapPlaces";
import DialogLayout from "../../../../../partials/content/DialogLayout";
import Illustration from "../../../../../partials/content/Illustration";
function PosDeliveryAddress({
  onChangeAddress,
  countries = [],
  onCloseDialog,
}) {
  const { values, setFieldValue } = useFormikContext();
  const [countryOptions, setCountryOptions] = useState([]);
  const [openSearchMapPlaces, setOpenSearchMapPlaces] = useState(false);
  const [address, setAddress] = useState({
    recipient: values.recipient,
    address: values.address,
    city: values.city,
    province: values.province,
    postalCode: values.postalCode,
    phoneNumber: values.phoneNumber,
    email: values.email,
  });
  useEffect(() => {
    const countriesTmp = [];
    for (const country of countries) {
      countriesTmp.push({
        value: country.countryCode,
        label: country.countryName,
      });
    }
    setCountryOptions(countriesTmp);
  }, [countries]);
  return (
    <React.Fragment>
      <div className="row mb-3">
        <div className="col-sm-12 col-md-12 col-lg-12">
          <Card>
            <Card.Header>
              <i className="fas fa-sitemap"></i>
              <span>
                <strong>Items To Be Delivered / Picked Up</strong>
              </span>
            </Card.Header>
            <Card.Body>
              <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12">
                  <div className="card">
                    <Table striped borderless size="sm" responsive="xl">
                      {values.salesPosItem &&
                      values.salesPosItem.filter((item) => item.receiveType > 1)
                        .length > 0 ? (
                        <thead>
                          <tr>
                            <th style={{ width: "30%" }}>
                              <Typography className="mx-1 kt-font-bolder">
                                Item Name
                              </Typography>
                            </th>
                            <th style={{ width: "20%" }}>
                              <Typography className="mx-1 kt-font-bolder">
                                Request Quantity
                              </Typography>
                            </th>
                            <th style={{ width: "20%" }}>
                              <Typography className="mx-1 kt-font-bolder">
                                Receive Type
                              </Typography>
                            </th>
                            <th style={{ width: "30%" }}>
                              <Typography className="mx-1 kt-font-bolder">
                                Location
                              </Typography>
                            </th>
                          </tr>
                        </thead>
                      ) : null}
                      <tbody>
                        {values.salesPosItem &&
                        values.salesPosItem.filter(
                          (item) => item.receiveType > 1
                        ).length > 0 ? (
                          values.salesPosItem
                            .filter((item) => item.receiveType > 1)
                            .map((item, index) => (
                              <tr key={index}>
                                <td>
                                  <Typography className="mx-1 my-1">
                                    {item.itemName}
                                  </Typography>
                                </td>
                                <td>
                                  <Typography className="mx-1 my-1">
                                    {item.qty}
                                  </Typography>
                                </td>
                                <td>
                                  <Typography className="mx-1 my-1">
                                    {item.receiveType === 2
                                      ? "Delivery"
                                      : "Item Request"}
                                  </Typography>
                                </td>
                                <td>
                                  <Typography className="mx-1 my-1">
                                    {item.warehouseName}
                                  </Typography>
                                </td>
                              </tr>
                            ))
                        ) : (
                          <tr>
                            <td className="text-center" colSpan="4">
                              <Illustration
                                guidance="No items ready to be delivered yet"
                                guidanceLeftIcon="fas fa-info-circle kt-font-warning"
                              ></Illustration>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </div>
                </div>
              </div>
            </Card.Body>
          </Card>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-12 col-md-12 col-lg-12">
          <Card>
            <Card.Header>
              <i className="fas fa-map-marked-alt"></i>
              <span>
                <strong>Shipping Address</strong>
              </span>
            </Card.Header>
            <Card.Body>
              <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12">
                  <FormTextField label="Ship To" name="recipient" />
                  <div className="row">
                    <div className="col-sm-6 col-md-6 col-lg-6">
                      <FormTextField
                        label="Address"
                        name="address"
                        mapsButton
                        onMapsClick={() => {
                          setOpenSearchMapPlaces(true);
                        }}
                      />
                      <FormTextField label="City" name="city" />
                      <FormTextField label="Province / State" name="province" />
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-6">
                      <FormTextField label="Phone Number" name="addressPhone" />
                      <FormTextField label="Email" name="addressEmail" />
                      <FormTextField label="Postal Code" name="postalCode" />
                    </div>
                  </div>
                  <FormSelectField
                    label="Country"
                    name="countryCode"
                    options={countryOptions}
                  />
                </div>
              </div>
            </Card.Body>
          </Card>
        </div>
      </div>
      <DialogActions>
        <button
          type="button"
          className="btn btn-label-danger btn-md btn-pill btn-bold"
          onClick={() => {
            onCloseDialog();
          }}
        >
          <i className="fas fa-window-close"></i>
          Close
        </button>
        <button
          type="button"
          className="btn btn-success btn-md btn-pill btn-bold"
          onClick={() => {
            //onChangeAddress(address);
          }}
        >
          <i className="fas fa-save"></i>
          Save
        </button>
      </DialogActions>
      <DialogLayout
        open={openSearchMapPlaces}
        title="Search Address on Maps"
        onCloseDialog={() => {
          setOpenSearchMapPlaces(false);
        }}
        maxWIdth="lg"
        minHeight={true}
      >
        <MapPlaces
          address={values.address}
          city={values.city}
          province={values.province}
          countryCode={values.countryCode}
          postalCode={values.postalCode}
          onPinLocation={(
            selectedFormattedAddress,
            selectedShortAddressComponents,
            selectedLongAddressComponents,
            selectedAddress,
            selectedCity,
            selectedProvince,
            selectedCountryCode,
            selectedPostalCode
          ) => {
            setFieldValue(`address`, selectedAddress);
            setFieldValue(`city`, selectedCity);
            setFieldValue(`province`, selectedProvince);
            setFieldValue(`countryCode`, selectedCountryCode);
            setFieldValue(`postalCode`, selectedPostalCode);
            setOpenSearchMapPlaces(false);
          }}
          onCloseDialog={() => {
            setOpenSearchMapPlaces(false);
          }}
        />
      </DialogLayout>
    </React.Fragment>
  );
  function changeAddress(value, propertyName) {
    const addressChange = { ...address };
    addressChange[propertyName] = value;
    setAddress(addressChange);
  }
}

export default PosDeliveryAddress;
